import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ShowSpace from '../../components/ShowSpace';
import { useNavigate, useParams } from 'react-router-dom';
import ValidatePageAccess from '../../components/api/ValidatePageAccess';

function MySpaceViewer() {
  const [pageAcces, SetPageAcces] = useState(false)
  const { siteId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const GetPageAccess = async () => {
      let response = await ValidatePageAccess(siteId, 'comfort/building')
      SetPageAcces(response)
      if(!response) navigate(`/projects/${siteId}/buildingoverview`)
    } 
  
    GetPageAccess()
  }, [siteId, navigate])

  return (
    <>
    {
      pageAcces ? (
        <Box m="18px">
          <ShowSpace/>
        </Box>
      ) : (
        null
      )
    }
    </>
  );
}

export default MySpaceViewer;
